<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="预约信息"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto',minWidth: form_min_width,}" autocomplete="off">
            <el-form-item label="特属服务对象">
                <el-input type="text" v-model="ruleForm.user_info" placeholder="请输入特属服务对象联系电话" autocomplete="off"
                          style="width: 100%;" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="特属服务对象联系电话">
                <el-input type="text" v-model="user_mobile" placeholder="请输入特属服务对象联系电话" autocomplete="off"
                          style="width: 100%;" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="联系人">
                <el-select v-model="ruleForm.contact_id" filterable @change="changeContact" placeholder="请选择联系人"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allAssistant"
                        :key="item.user_id"
                        :label="item.user_name"
                        :value="item.user_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="联系人联系电话">
                <el-input type="text" v-model="ruleForm.contact_mobile" placeholder="请输入联系人联系电话" autocomplete="off"
                          style="width: 100%;" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="特属专家" prop="doctor_id">
                <el-select class="doctor" v-model="ruleForm.doctor_id" filterable @change="changeDoctor" placeholder="请选择特属专家"
                           style="width: 100%;" v-if="user_role == 2" :disabled="true">
                    <el-option
                        v-for="item in allDoctor"
                        :key="item.user_id"
                        :label="item.doctor_name"
                        :value="item.user_id"
                    ></el-option>
                </el-select>
                <el-select v-model="ruleForm.doctor_id" filterable @change="changeDoctor" placeholder="请选择特属专家"
                           style="width: 100%;" v-if="user_role != 2">
                    <el-option
                        v-for="item in allDoctor"
                        :key="item.user_id"
                        :label="item.doctor_name"
                        :value="item.user_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="特属专家联系电话">
                <el-input type="text" v-model="doctor_mobile" placeholder="请输入特属专家联系电话" autocomplete="off"
                          style="width: 100%;" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status"  @change="statusChange">
                    <el-radio :label="1" disabled>预约处理</el-radio>
                    <el-radio :label="2">等待会面</el-radio>
                    <el-radio :label="3" disabled v-if="user_role > 3 || old_status == 1">会面完成</el-radio>
                    <el-radio :label="3" v-if="user_role <= 3 && old_status>1 ">会面完成</el-radio>
                    <el-radio :label="4">会面中断</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="取消原因" prop="remark" v-if="is_interrupt">
                <el-input type="textarea" id="remark" v-model="ruleForm.remark" placeholder="请输入取消会面原因" autocomplete="off"
                          style="width: 100%;" maxlength="30" autosize></el-input>
            </el-form-item>

            <el-form-item label="特属服务专员">
                <el-select v-model="ruleForm.input_user_id" placeholder="请选择特属服务专员" style="width: 100%;" v-if="user_role != 2">
                    <el-option
                        v-for="item in allManager"
                        :key="item.user_id"
                        :label="item.user_name"
                        :value="item.user_id"
                    ></el-option>
                </el-select>
                <el-input type="text" v-model="ruleForm.input_user_name"  autocomplete="off"
                          style="width: 100%;" :disabled="true" v-if="user_role == 2"></el-input>
            </el-form-item>
            <el-form-item label="会面地点" prop="address_id" v-if="ruleForm.status == 2 || ruleForm.status == 3">
                <el-select v-model="ruleForm.address_id" placeholder="请选择会面地址" style="width: 100%;">
                    <el-option
                        v-for="item in doctorAddress"
                        :key="item.id"
                        :label="item.address_info"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="期望会面时间" prop="book_date" v-if="ruleForm.status != 3">
                <el-input type="text" v-model="ruleForm.book_date" placeholder="期望会面时间" autocomplete="off"
                          style="width: 100%;" :disabled="true"></el-input>
<!--                <el-date-picker-->
<!--                    v-model="ruleForm.book_date"-->
<!--                    type="date"-->
<!--                    placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">-->
<!--                </el-date-picker>-->
            </el-form-item>
            <el-form-item prop="half">
                <el-radio-group v-model="ruleForm.half" :disabled="true">
                    <el-radio :label="1">上午</el-radio>
                    <el-radio :label="2">下午</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="会面日期" prop="meet_date" v-if="ruleForm.status == 2 || ruleForm.status == 3 || ruleForm.detail_meet_date">
                <el-date-picker
                    v-model="ruleForm.meet_date"
                    type="date"
                    placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="会面时间" prop="meet_time" v-if="ruleForm.status == 2 || ruleForm.status == 3 || ruleForm.detail_meet_time">
                <el-select v-model="ruleForm.meet_time" filterable placeholder="请选择会面时间"
                           style="width: 100%;">
                    <el-option
                        v-for="item in time_frame"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                    ></el-option>
                </el-select>
            </el-form-item>
<!--            <el-form-item label="安置处理服务" prop="guid_status" v-if="ruleForm.status == 3">-->
<!--                <el-radio-group v-model="ruleForm.guid_status" >-->
<!--                    <el-radio :label="1">有</el-radio>-->
<!--                    <el-radio :label="2">无</el-radio>-->
<!--                </el-radio-group>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="检查事宜服务" prop="check_status" v-if="ruleForm.status == 3">-->
<!--                <el-radio-group v-model="ruleForm.check_status" >-->
<!--                    <el-radio :label="1">有</el-radio>-->
<!--                    <el-radio :label="2">无</el-radio>-->
<!--                </el-radio-group>-->
<!--            </el-form-item>-->
            <!-- form表单提交 -->
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import {getFormatDate} from "@/utils/date";
import {isMobile} from "@/api/order";

export default {
    created() {
        if (isMobile()) {
            this.form_min_width = "none"
            this.form_width = "100%"
        }
        localStorage.setItem('prev_page', 'work_edit')

        let user_info = getUserInfos()

        this.user_role = user_info.role_id
        if (this.$route.query.reservation_id) {
            this.reservation_id = this.$route.query.reservation_id;
            this.reservationDetail()
        } else {
            this.reservation_id = this.$route.params.reservation_id;
            this.user_id = this.$route.params.user_id;
            this.ruleForm.status = 2;
            this.is_interrupt = false;
            this.old_status = this.$route.params.status;
            this.ruleForm.meet_time = this.$route.params.meet_time;
            if (this.$route.params.status == 1) {
                let book_date = (this.$route.params.book_date).split(' ')[0]
                if ((new Date()).getTime() > (new Date(book_date)).getTime()) {
                    this.ruleForm.meet_date = getFormatDate("Y-m-d", ((new Date()).getTime())/1000)
                } else {
                    this.ruleForm.meet_date = book_date;
                }
            } else {
                this.ruleForm.meet_date = this.$route.params.meet_date;
            }
            this.ruleForm.address_id = this.$route.params.address_id;
            this.ruleForm.user_info = this.$route.params.bloc_name + '/' + this.$route.params.user_name
        }
    },
    mounted() {

        if(!this.$route.query.reservation_id) {
            this.getAddEditParams();

            this.user_mobile = this.$route.params.user_mobile;
            this.doctor_mobile = this.$route.params.doctor_mobile;

            if (this.$route.params.user_id == this.$route.params.contact_id) {
                this.ruleForm.contact_mobile = this.$route.params.user_mobile;
            } else {
                this.ruleForm.contact_mobile = this.$route.params.contact_mobile;
            }

            this.ruleForm.book_date = this.$route.params.book_date.split(' ')[0];
            if (this.$route.params.half == '上午') {
                this.ruleForm.half = 1;
                // this.ruleForm.meet_time = '8:00~9:00';
            }
            if (this.$route.params.half == '下午') {
                this.ruleForm.half = 2;
                // this.ruleForm.meet_time = '14:00~15:00';
            }
            this.ruleForm.remark = this.$route.params.remark;
            let userData = getUserInfos();
            this.ruleForm.input_user_id = this.$route.params.assistant_id;

        }

    },
    data() {
        return {
            allUser: [],
            allAssistant: [],
            allDoctor: [],
            allManager: [],
            doctorAddress: [],
            reservation_id: '',
            input_user_name: '',
            user_mobile: '',
            doctor_mobile: '',
            user_id: "",
            user_name: "",
            user_role: 0,
            is_interrupt: false,
            time_frame: [
                {id: 1, name: "8:00~9:00"},
                {id: 2, name: "9:00~10:00"},
                {id: 3, name: "10:00~11:00"},
                {id: 4, name: "11:00~12:00"},
                {id: 5, name: "12:00~13:00"},
                {id: 6, name: "13:00~14:00"},
                {id: 7, name: "14:00~15:00"},
                {id: 8, name: "15:00~16:00"},
                {id: 9, name: "16:00~17:00"},
                {id: 10, name: "17:00~18:00"},
            ],
            ruleForm: {
                user_id: "",
                doctor_id: "",
                contact_id: "",
                contact_name: "",
                contact_mobile: "33333333333",
                book_date: "",
                half: 1,
                status: 1,
                check_status: '',
                guid_status: '',
                remark: "",
                input_user_id: '',
                input_user_name: '',
                address_id: '',
                meet_date: '',
                meet_time: '',
                user_info: '',
                detail_meet_date: '',
                detail_meet_time: '',
            },
            rules: {
                user_id: [
                    {required: true, message: "请选择特属服务对象", trigger: "blur"},
                ],
                doctor_id: [
                    {required: true, message: "请选择特属专家", trigger: "blur"},
                ],
                status: [
                    {required: true, message: "请选择状态", trigger: "blur"},
                ],
                book_date: [
                    {required: true, message: "请选择期望会面时间", trigger: "blur"},
                ],
                half: [
                    {required: true, message: "请选择上午或下午", trigger: "blur"},
                ],
                input_user_name: [
                    {required: true, message: "请选择特属服务专员", trigger: "blur"},
                ],
                address_id: [
                    {required: true, message: "请选择会面地址", trigger: "blur"},
                ],
                meet_date: [
                    {required: true, message: "请选择会面日期", trigger: "blur"},
                ],
                meet_time: [
                    {required: true, message: "请选择会面时间", trigger: "blur"},
                ],
                remark: [
                    {required: true, message: "请输入会面中断原因", trigger: "blur"},
                ],
                guid_status: [
                    {required: true, message: "请选择本次服务是否有安置处理服务", trigger: "blur"},
                ],
                check_status: [
                    {required: true, message: "请选择本次服务是否有检查事宜服务", trigger: "blur"},
                ],
            }, pickerOptions: {
                disabledDate: (time) => {
                    return time.getTime() < Date.now() - 8.64e7;  // 当天之前不可选
                }
            },
            is_submit: false,
            old_status: 0,// 记录从列表也的哪个模块进入的
            form_width: "40%",
            form_min_width: "640px"
        };
    },
    methods: {
        // 预约单详情
        reservationDetail() {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'reservationDetail',
                params: {
                    reservation_id: this.reservation_id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data.detail) {

                    let dataInfo = res.data.data.detail;

                    this.user_id = dataInfo.user_id;
                    this.ruleForm.status = 2;
                    this.old_status = dataInfo.status;
                    if (dataInfo.address_id > 0) {
                        this.ruleForm.address_id = dataInfo.address_id;
                    }
                    if (dataInfo.status == 1) {
                        this.ruleForm.meet_date = dataInfo.book_date;
                    } else {
                        this.ruleForm.meet_date = dataInfo.meet_date;
                    }

                    this.ruleForm.detail_meet_date = dataInfo.meet_date;
                    this.ruleForm.detail_meet_time = dataInfo.meet_time;
                    this.ruleForm.meet_time = dataInfo.meet_time;
                    this.ruleForm.user_info = dataInfo.bloc_name + '/' + dataInfo.user_name

                    this.getAddEditParams(dataInfo);

                    this.user_mobile = dataInfo.user_mobile;
                    this.doctor_mobile = dataInfo.doctor_mobile;

                    if (dataInfo.user_id == dataInfo.contact_id) {
                        this.ruleForm.contact_mobile = dataInfo.user_mobile;
                    } else {
                        this.ruleForm.contact_mobile = dataInfo.contact_mobile;
                    }

                    this.ruleForm.book_date = dataInfo.book_date;

                    if (dataInfo.half == '上午') {
                        this.ruleForm.half = 1;
                    }
                    if (dataInfo.half == '下午') {
                        this.ruleForm.half = 2;
                    }

                    this.ruleForm.remark = dataInfo.remark;

                    let userData = getUserInfos();
                    this.ruleForm.input_user_id = dataInfo.assistant_id;
                    for (let i = 0; i < this.allManager.length; i++) {
                        if (this.allManager[i].user_id == this.ruleForm.input_user_id) {
                            this.ruleForm.input_user_name = this.allManager[i].user_name
                        }
                    }
                }


            });
        },
        // 所有特属服务对象，特属专家
        getAddEditParams(dataInfo = '') {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'addEditParams',
                params: {
                    reservation_id: this.reservation_id,
                    status: this.ruleForm.status
                }
            };
            this.$api.service(params).then(res => {
                if (dataInfo) {
                    this.getAssistant(dataInfo.contact_id);
                } else {
                    this.getAssistant();
                }

                if (!check(res)) {
                    return;
                }

                if (dataInfo) {
                    this.allDoctor = res.data.data.doctor;
                    this.allManager = res.data.data.manager;
                    this.ruleForm.doctor_id = dataInfo.doctor_id;
                    this.getAddress()
                    this.ruleForm.user_id = dataInfo.user_id;
                    this.ruleForm.input_user_id = dataInfo.assistant_id;
                    //刷新未读数
                    if (this.reservation_id != "") {
                        this.$store.commit("websocket/SET_MESSAGE", this.reservation_id);
                    }
                } else {
                    this.allDoctor = res.data.data.doctor;
                    this.allManager = res.data.data.manager;
                    this.ruleForm.doctor_id = this.$route.params.doctor_id;
                    this.getAddress()
                    this.ruleForm.user_id = this.$route.params.user_id;
                    this.ruleForm.input_user_id = this.$route.params.assistant_id;
                    //刷新未读数
                    if (this.reservation_id != "") {
                        this.$store.commit("websocket/SET_MESSAGE", this.reservation_id);
                    }
                }
                for (let i = 0; i < this.allManager.length; i++) {
                    if (this.allManager[i].user_id == this.$route.params.assistant_id) {
                        this.ruleForm.input_user_name = this.allManager[i].user_name
                        break;
                    }
                }

            });
        },

        // 获取子账户
        getAssistant(contact_id = '') {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'getAssistant',
                params: {
                    user_id: this.user_id
                }
            };

            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }

                if (res.data.data) {
                    this.allAssistant = res.data.data.assistantList;
                    this.allDoctor = res.data.data.doctorList;
                    if (contact_id) {
                        this.ruleForm.contact_id = contact_id;
                    } else {
                        this.ruleForm.contact_id = this.$route.params.contact_id;
                    }

                }

            });
        },

        // 返回上一页
        goBack() {
            window.history.go(-1);
            return;
        },
        // 状态修改
        statusChange(v) {
            if (v == 4) {
                this.is_interrupt = true
                var timer = setInterval(function () {
                    let remark = document.getElementById("remark")
                    remark.focus()
                    clearTimeout(timer)
                }, 100)
            } else {
                this.is_interrupt = false
            }
        },
        // 提交表单
        submitForm(formName) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let _that = this
            if (this.ruleForm.status == 4 && !this.ruleForm.remark) {
                this.$message({
                    type: "error",
                    message: '请输入会面中断原因'
                });
                let remark = document.getElementById("remark")
                remark.focus()
                this.is_submit = false;
                return false;
            }

            this.$refs[formName].validate(valid => {

                if (valid) {
                    let params = {
                        'servername': 'Ruyi_AdminWorkbenchServices',
                        'method': 'editReservation',
                        'params': {
                            reservation_id: this.reservation_id,
                            user_id: this.ruleForm.user_id,
                            doctor_id: this.ruleForm.doctor_id,
                            contact_id: this.ruleForm.contact_id,
                            book_date: this.ruleForm.book_date,
                            half: this.ruleForm.half == 1 ? '上午' : '下午',
                            status: this.ruleForm.status,
                            remark: this.ruleForm.remark,
                            input_user_id: this.ruleForm.input_user_id,
                            address_id: this.ruleForm.address_id,
                            meet_date: this.ruleForm.meet_date,
                            meet_time: this.ruleForm.meet_time,
                            guid_status: this.ruleForm.guid_status,
                            check_status: this.ruleForm.check_status,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '修改成功',
                            duration: 1500,
                            onClose: function () {
                                _that.is_submit = false;
                                window.history.go(-1);
                                return;
                            }
                        });
                    }).catch(()=>{
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    this.is_submit = false;
                    return false;
                }
            });
        },

        changeDoctor() {

            let allDoctor = this.allDoctor;
            let user_id = this.ruleForm.doctor_id;
            this.ruleForm.address_id = null;
            let mobile;
            for (var i = 0; i < allDoctor.length; i++) {
                if (allDoctor[i].user_id == user_id) {
                    mobile = allDoctor[i].mobile;
                }
            }
            this.doctor_mobile = mobile;
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'getManager',
                params: {
                    doctor_id: this.ruleForm.doctor_id
                }
            };

            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.ruleForm.address_id = '';
                this.ruleForm.input_user_id = '';
                this.allManager = res.data.data.managerList;
                this.doctorAddress = res.data.data.addressList;
                for (let i = 0; i < this.doctorAddress.length; i++) {
                    if (this.doctorAddress[i].is_default == 1 || this.doctorAddress.length == 1) {
                        this.ruleForm.address_id = this.doctorAddress[i].id;
                    }
                }
            });
        },

        // 选择子账户
        changeContact() {
            let allAssistant = this.allAssistant;
            let contact_id = this.ruleForm.contact_id;
            let mobile;
            for (var i = 0; i < allAssistant.length; i++) {
                if (allAssistant[i].user_id == contact_id) {
                    mobile = allAssistant[i].mobile;
                }
            }
            this.ruleForm.contact_mobile = mobile;
        },

        // 获取特属专家关联地址
        getAddress() {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'getAddress',
                params: {
                    doctor_id: this.ruleForm.doctor_id
                }
            };

            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data) {
                    this.doctorAddress = res.data.data;
                    for (let i = 0; i < this.doctorAddress.length; i++) {
                        if (this.doctorAddress[i].id > 0 && (this.doctorAddress[i].is_default == 1 || this.doctorAddress.length == 1)) {
                            this.ruleForm.address_id = this.doctorAddress[i].id;
                        }
                    }
                }

            });
        }
    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 316px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 316px;
    height: 200px;
    display: block;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.el-select.doctor {
    .el-icon-arrow-up {
        color: #fff;
    }
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}
</style>
